import { Input, SingleDatePicker } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useEndDate } from './hooks/useEndDate';
import { useEndTime } from './hooks/useEndTime';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

export const EndDateAndTimeControl = () => {
  const { t } = useTranslation('campaigns');

  const { endDate, validation, ...endDateRest } = useEndDate();
  const { endTime, onEndTimeChanged } = useEndTime();

  return (
    <Container>
      <SingleDatePicker
        date={endDate}
        label={t('onsite.editor.workflow.scheduling.endDate')}
        ariaLabel={t('onsite.editor.workflow.scheduling.endDateAria')}
        placeholder={t('onsite.editor.workflow.scheduling.endDatePlaceholder')}
        validationState={validation.passed ? '' : 'warning'}
        validationMessage={validation.passed ? undefined : validation.validationMessage}
        spacingBelow={false}
        {...endDateRest}
      />
      {endDate && (
        <Input
          value={endTime ?? '23:59'}
          onChange={onEndTimeChanged}
          ariaLabel={t('onsite.editor.workflow.scheduling.endTimeAria')}
          label={t('onsite.editor.workflow.scheduling.timeLabel')}
          type="time"
          style={{ width: 85, height: 50 }}
          spacingBelow={false}
        />
      )}
    </Container>
  );
};
